import React from 'react';
import * as S from './style';
import { Row, SpaceDiv, BtnNext, BtnContainer } from 'components';
import PhoneAuth, { Props as PhoneAuthProps } from 'components/molecules/PhoneAuth';
import PhoneAuthCode, { Props as PhoneAuthCodeProps } from 'components/molecules/PhoneAuthCode';
import * as PAGE_URL from 'router/PageUrl';
import { BUTTON_SIGNUP_2 } from 'commons/ZimssaString';

interface Props {
    phone: PhoneAuthProps;
    authCode: PhoneAuthCodeProps;
    btnNext: {
        contents: string;
        isActive: boolean;
        isComplete: boolean;
        onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    };
}

function Login({ ...props }: Props): React.ReactElement {
    return (
        <S.LoginContainer>
            <Row>
                <PhoneAuth {...props.phone} />
                {props.phone.isSend ? <PhoneAuthCode {...props.authCode} /> : null}
            </Row>
            <SpaceDiv height={12} />
            <BtnContainer>
                <BtnNext {...props.btnNext} />
            </BtnContainer>
            <S.BtnWrapper>
                <S.BtnSignUpStyled fontStyle={'body2'} color={'blue_900'} backGroundColor={'transparent'} href={PAGE_URL.SIGNUP.path}>
                    {BUTTON_SIGNUP_2}
                </S.BtnSignUpStyled>
            </S.BtnWrapper>
        </S.LoginContainer>
    );
}

export default Login;
